import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';
import { LanguageService } from '../../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ErorModalComponent } from './eror-modal/eror-modal.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { EditProductModalComponent } from './edit-product-modal/edit-product-modal.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

@NgModule({
  declarations: [TopbarComponent, FooterComponent, SidebarComponent, RightsidebarComponent, SpinnerComponent, ErorModalComponent, SuccessModalComponent, EditProductModalComponent, ConfirmationModalComponent,],
  imports: [
    CommonModule,
    TranslateModule,
    PerfectScrollbarModule,
    NgbDropdownModule,
    ClickOutsideModule,
    RouterModule,
    ReactiveFormsModule
  ],
  exports: [TopbarComponent, FooterComponent, SidebarComponent, RightsidebarComponent,SpinnerComponent],
  providers: [LanguageService]
})
export class SharedModule { }
